import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import Spinner from "shared/components/spinner"
import spinnerConfig from "../utils/spinner_config"

import { GetMoreSection } from "./get_more_section"
import { fetchSections } from "../reducers/get_more_results"
import { connectionShape, serviceShape, partialStoryShape } from "app/lib/shared_prop_types"

import upsellPlugHOC from "./upsell_plug_hoc"

export class GetMoreView extends Component {
  constructor(props) {
    super(props)
    props.fetchResults()
  }

  loadMoreResults = () => {
    if (this.props.offset < this.props.limit && !this.props.loading && this.props.belowFoldLoaded) {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight * 0.65) {
        this.props.fetchResults()
      }
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.loadMoreResults, { passive: true })
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.loadMoreResults, {
      passive: true,
    })
  }

  render() {
    return (
      <div className={`get-more-results ${this.props.currentView}`}>
        <div className="get-more">
          {this.props.getMoreSections.map((section, idx) => {
            return (
              <GetMoreSection
                key={idx}
                section={section}
                diyPath={this.props.diyPath}
                currentView={this.props.currentView}
              />
            )
          })}
        </div>
        {this.props.loading && <Spinner config={spinnerConfig} />}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const offset = state.getMoreResults.offset || 0
  let getMoreSections = []

  if (state.getMoreResults.getMoreSections) {
    getMoreSections = state.getMoreResults.getMoreSections
  } else {
    const appletsOffset = offset * 8
    const servicesOffset = offset * 2
    const storiesOffset = offset * 2

    const getMoreSection = {
      applets: state.getMoreResults.applets.slice(appletsOffset, appletsOffset + 8),
      services: state.getMoreResults.services.slice(servicesOffset, servicesOffset + 2),
      stories: state.getMoreResults.stories.slice(storiesOffset, storiesOffset + 2),
      appletsOffset,
      servicesOffset,
      storiesOffset,
    }

    getMoreSections = [getMoreSection]
  }

  return {
    currentView: state.viewToggle.currentView,
    getMoreSections,
    loading: state.getMoreResults.loading,
    origin: state.viewToggle.origin,
    diyPath: state.getMoreResults.diyPath,
    belowFoldLoaded: state.getMoreResults.belowFoldLoaded,
    offset,
    limit: state.getMoreResults.limit,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchResults: () => dispatch(fetchSections()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(upsellPlugHOC(GetMoreView))

GetMoreView.propTypes = {
  currentView: PropTypes.string,
  getMoreSections: PropTypes.arrayOf(
    PropTypes.shape({
      applets: PropTypes.arrayOf(connectionShape),
      services: PropTypes.arrayOf(serviceShape),
      stories: PropTypes.arrayOf(partialStoryShape),
      servicesOffset: PropTypes.number,
      appletsOffset: PropTypes.number,
      storiesOffset: PropTypes.number,
    })
  ),
  fetchResults: PropTypes.func,
  fetchMoreResults: PropTypes.func,
  offset: PropTypes.number,
  limit: PropTypes.number,
  belowFoldLoaded: PropTypes.bool,
  loading: PropTypes.bool,
  diyPath: PropTypes.string,
  origin: PropTypes.string,
}

GetMoreView.defaultProps = {
  getMoreSections: [],
  loading: false,
}
